$(function () {
  /*  Animation */
  new WOW().init();
  /* fixed header */
  jQuery(window).scroll(function () {
    if (jQuery(this).scrollTop()) {
      jQuery("header").addClass("fixed-header");
      jQuery("body").addClass("on-fixed");
    } else {
      jQuery(".main-header").removeClass("fixed-header");
      jQuery("body").removeClass("on-fixed");
    }
  });
});

$(document).ready(function () {
  /*  Preloader  */

  jQuery(".menu-toggle").click(function () {
    jQuery("body").toggleClass("header-logo");
    jQuery(".menu").toggleClass("active");
    jQuery(".menu-toggle").toggleClass("menu-open");
  });

  var btn = $(".go-top");

  $(window).scroll(function () {
    if ($(window).scrollTop() > 400) {
      btn.addClass("show");
    } else {
      btn.removeClass("show");
    }
  });

  btn.on("click", function (e) {
    e.preventDefault();
    $("html, body").animate({ scrollTop: 0 }, "300");
  });


jQuery('.show-action').click(function () {
  jQuery(".info-section .text-wrapper").toggleClass("auto-height");
  jQuery(".read-more").toggleClass("d-none");
  jQuery(".read-less").toggleClass("d-none");

});

});

const observer = lozad(); // lazy loads elements with default selector as '.lozad'
observer.observe();
document.addEventListener("DOMNodeInserted", function (event) {
  observer.observe();
});




var html5lightbox_options = {
  fullscreenmode: "true",
  watermark: "http://html5box.com/images/html5boxlogo.png",
        watermarklink: ""
};